import React from 'react';
import HistoryItemCard from 'src/components/10-atoms/Card/HistoryItemCard';
import TextButton from 'src/components/10-atoms/button/TextButton';
import FormattedDate from 'src/components/10-atoms/date/FormattedDate';
import HTMLDiffRenderer from 'src/components/10-atoms/form/inputs/editor/html/HTMLEditor/DiffRenderer';
import Row from 'src/components/10-atoms/layout/Row';
import { TypographyVariant } from 'src/customizations/themes/10-parts/typography';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
import useI18n from 'src/modules/translations/hooks/useI18n';
const NoteTabHistoryItem = ({ item, prevItem, onRevert, ...columnProps }) => {
    const [{ theme }] = useTheme(stylesGenerator);
    const { translate } = useI18n();
    const currentContent = item.content;
    const prevContent = prevItem?.content ?? '';
    return (React.createElement(HistoryItemCard, { spacingY: theme.spacing.standard.lg, ...columnProps },
        React.createElement(HTMLDiffRenderer, { enableCachedImage: true, oldHtml: prevContent, newHtml: currentContent }),
        React.createElement(Row, { xAxis: "space-between", yAxis: "center" },
            item.ts ? (React.createElement(FormattedDate, { mode: "relative", date: new Date(item.ts), variant: TypographyVariant.CAPTION, color: theme.palette.typography.secondary })) : React.createElement(Row, null),
            React.createElement(TextButton, { size: "sm", onPress: () => onRevert(item) }, translate('Revert to this Version')))));
};
const stylesGenerator = createThemedStyle(() => ({}));
export default NoteTabHistoryItem;
